export default __webpack_public_path__ + "static/media/customer_phones.a8d71c7f.png";